// extracted by mini-css-extract-plugin
module.exports = {"root":"xrXo+","btn":"uP0jC","tooltip":"WZYGl","loader":"_8Ax5o","rotation":"dn+RO"};